import { useMemo } from 'react';
import { Chart as ChartJS } from 'chart.js';
import { defaultPlugins, optionalPlugins } from './index';
const optionalPluginsMap = optionalPlugins.reduce((acc, plugin) => {
    acc.set(plugin.id, plugin);
    return acc;
}, new Map());
function detectRequiredPlugins(options) {
    if (!options)
        return [];
    if ('plugins' in options && options.plugins !== undefined) {
        return Array.from(Object.entries(options.plugins).reduce((acc, [key, value]) => {
            if (value) {
                const plugin = optionalPluginsMap.get(key);
                if (plugin)
                    acc.add(plugin);
            }
            return acc;
        }, new Set()));
    }
    return [];
}
const registered = new Set();
/* Detect required plugins from options. */
export function useRequiredChartPlugins(options) {
    const plugins = useMemo(() => {
        if (!options)
            return [];
        const requiredPlugins = detectRequiredPlugins(options)
            .concat(defaultPlugins)
            .filter((plugin) => !registered.has(plugin));
        ChartJS.register(...requiredPlugins);
        requiredPlugins.forEach((p) => registered.add(p));
        return requiredPlugins;
    }, [options]);
    return plugins;
}
